import styled from '@emotion/styled';
import { Typography } from '@mui/material';
import { ExperienceFieldsFragment, ExperienceType } from '@/generated/graphql';
import { OneOnOneActions } from './one-on-one-actions';
import MobileEventActions from './mobile-event-actions';
import { BoxActions } from './box-actions';

const TimesWrapperMobile = styled.div`
  display: none;
  flex-direction: row;
  height: auto;
  width: 100%;
  padding: 29px;
  align-items: center;
  justify-content: center;
  background-color: white;
  border-top: 2px solid #c990bf;
  @media (max-width: 768px) {
    position: fixed;
    bottom: 0;
    z-index: 1000;
    display: flex;
  }
`;
const BoxExperience = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: center;
  column-gap: 10px;
  width: 100%;
`;
const BoxOnlyTitle = styled(Typography)`
  font-family: var(--font-work-sans);
  font-style: normal;
  color: #7c7c7c;
  font-size: 16px;
  font-weight: 500;
  line-height: 157.3%;
  width: 55%;
  text-align: start;
`;

export interface BookingCardProps {
  experience: ExperienceFieldsFragment;
}
const MobileActionFooter = ({ experience }: BookingCardProps) => {
  const type = experience?.type;
  return (
    <TimesWrapperMobile>
      {type === ExperienceType.Box && (
        <BoxExperience>
          <BoxOnlyTitle>Boxes are free - just pay for shipping!</BoxOnlyTitle>
          <BoxActions experience={experience} />
        </BoxExperience>
      )}
      {type === ExperienceType.Schedule && <OneOnOneActions experience={experience} />}
      {type === ExperienceType.Event && <MobileEventActions experience={experience} />}
    </TimesWrapperMobile>
  );
};

export default MobileActionFooter;
